import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Container, Grid, Popup, Confirm, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import TechnicianProjectStore from '../../app/stores/technicianprojectStore';
import PhotoDropzone from '../../app/common/Dropzone/PhotoDropzone';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../app/stores/rootStore';
import { Link } from 'react-router-dom';

const TechnicianProject = () => {
  // const rootStore = useContext(RootStoreContext);
  // const { user } = rootStore.userStore;
  const technicianprojectStore = useContext(TechnicianProjectStore);
  const {loadTechnicianProjects, technicianprojectsByDate, loadingInitial} = technicianprojectStore;
  
  useEffect(() => {
    loadTechnicianProjects();
  }, []);

  if (loadingInitial) return <LoadingComponent content='Loading projects...' />
 
  return (
      <Table celled unstackable size='small'>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell width={1}>Code</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {technicianprojectsByDate.map(project => (
      <Table.Row key={project.id}>
        <Table.Cell>
          <Label>{project.projectCode}</Label>
        </Table.Cell>
        <Table.Cell>{project.address}</Table.Cell>
        <Table.Cell>
        <Button.Group vertical> 
        <Button
                    as={Link}
                    to={`/employeeportal/photoupload/${project.id}`}
                    size="mini"
                    color="blue"
                    content="Photo"
                  />
        <Button
                    as={Link}
                    to={`/employeeportal/techniciansor/${project.id}`}
                    size="mini"
                    color="green"
                    content="SOR"
                  />
        </Button.Group>
        </Table.Cell>
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
  );
};

export default observer(TechnicianProject);
